import { axios } from '@/utils/request'

const api = {
  wxGetQRCode: '/sso/wxPlatform/wxGetQRCode', // 微信扫码登录获取二维码
  wxLoginAutoRegister: '/sso/wxPlatform/wxLoginAutoRegister', // 微信扫码完成登录用户自动注册
  wxBindOrUnbind: '/sso/wxPlatform/wxBindOrUnbind' // 微信扫码解绑或绑定
}

export default api
export const wxGetQRCode = async params => axios.post(api.wxGetQRCode, params) // 微信扫描相关
export const wxLoginAutoRegister = async params => axios.post(api.wxLoginAutoRegister, params)
export const wxBindOrUnbind = async params => axios.post(api.wxBindOrUnbind, Object.assign({ systemCode: 'SSO_SYS_USER' }, params))
